import {computed} from 'vue'
import {useI18n} from 'vue-i18n';
import {DocumentType} from "~~/api/models"

export interface DocumentIconType {
  value: number;
  icon: string[];
  label: string;
  isCreditNote: boolean;
}

export const documentTypes = computed<DocumentIconType[]>(() => {
  const {t} = useI18n();

  return [
    {
      value: DocumentType.Invoice,
      icon: ['far', 'dollar-sign'],
      label: t('document_types.invoice'),
      isCreditNote: false
    },
    {
      value: DocumentType.GoodsInvoice,
      icon: ['far', 'bag-shopping'],
      label: t('document_types.goods_invoice'),
      isCreditNote: false
    },
    {
      value: DocumentType.CustomerOrder,
      icon: ['far', 'list-check'],
      label: t('document_types.customer_order'),
      isCreditNote: false
    },
    {value: DocumentType.Expense, icon: ['far', 'receipt'], label: t('document_types.expense'), isCreditNote: false},
    {value: DocumentType.Travel, icon: ['far', 'credit-card'], label: t('document_types.travel'), isCreditNote: false},
    {value: DocumentType.Mileage, icon: ['far', 'truck'], label: t('document_types.mileage'), isCreditNote: false},
    {value: DocumentType.Split, icon: ['far', 'split'], label: t('document_types.split'), isCreditNote: false},
    {
      value: DocumentType.Requisition,
      icon: ['far', 'file-invoice'],
      label: t('document_types.requisition'),
      isCreditNote: false
    },
    {
      value: DocumentType.CreditNote,
      icon: ['far', 'dollar-sign'],
      label: t('document_types.credit_note'),
      isCreditNote: true
    },
    {
      value: DocumentType.GoodsCreditNote,
      icon: ['far', 'bag-shopping'],
      label: t('document_types.goods_credit_note'),
      isCreditNote: true
    }
  ];
});